import api from "./api";

export const userApi = {
  list: (query = "") => api.get(`/users${query}`),
  create: (payload) => api.post("/users", payload),
  update: (id, payload) => api.put(`/users/${id}`, payload),
  remove: (id) => api.delete(`/users/${id}`),
};
